import React from 'react';
import { useFormikContext } from 'formik';
import {
  OutgoingEventProductDto,
  EventProductType
} from 'api/dtos/events/products';
import StandardProductFields from './product-types/StandardProductFields';
import BundleFields from './product-types/BundleFields';
import { UserMe } from 'legacy/user/types';

interface ProductTypeFactoryProps {
  standardProducts: OutgoingEventProductDto[];
  user: UserMe;
  isUnsaved: (field: string) => boolean;
}

// This factory makes it easy to add new product types in the future
const ProductTypeFactory: React.FC<ProductTypeFactoryProps> = ({
  standardProducts,
  user,
  isUnsaved
}) => {
  const { values } = useFormikContext<any>();
  const productType = values.type as EventProductType;
  // Map of product types to their corresponding components
  // This makes it easy to add new product types in the future
  switch (productType) {
    case 'bundle':
      return (
        <BundleFields
          standardProducts={standardProducts}
          user={user}
          isUnsaved={isUnsaved}
        />
      );
    case 'admission':
      return (
        <StandardProductFields
          isAddon={false}
          user={user}
          isUnsaved={isUnsaved}
        />
      );
    case 'addon':
      return (
        <StandardProductFields
          isAddon
          user={user}
          isUnsaved={isUnsaved}
        />
      );
    default:
      // Fallback to standard product fields
      return (
        <StandardProductFields
          isAddon={false}
          user={user}
          isUnsaved={isUnsaved}
        />
      );
  }
};

export default ProductTypeFactory;
